import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';

import useIdleTimeout from 'hooks/use-idle-timeout';

export interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { oktaAuth, authState } = useOktaAuth();

  useIdleTimeout();

  if (!authState) {
    return null;
  }
  if (!authState.isAuthenticated) {
    const originalUri = window.location.href;

    oktaAuth.setOriginalUri(originalUri);

    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
